import { starterSteps } from "@/mocks/homeData";

export default function StarterGuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-route-line" />
            新手指引
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
            第一次使用，跟着四步走就够了
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            不论是网页端还是客户端，首次使用的流程其实是相通的。按顺序完成下面四步，就能顺利开始。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {starterSteps.map((item) => (
            <div
              key={item.step}
              className="relative rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <span className="font-heading text-accent-500 text-4xl md:text-5xl">{item.step}</span>
              <h3 className="mt-4 font-heading text-foreground-950 text-lg">{item.title}</h3>
              <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              <span className="absolute top-5 right-5 w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 text-lg">
                <i className="ri-arrow-right-up-line" />
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}